export enum ReportTypeEnum {
  ERA = 1,
  None,
  email,
  SMS,
  ERA2
}

export namespace ReportTypeEnum {
  export function values() {
    return Object.keys(ReportTypeEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
